<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="direction: rtl;display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="جستجو..." autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager">
            <span>
                <button (click)='insert()' class="new1">جديد</button>
                <button (click)='open_detaile(0,3,0)' class="search1" *ngIf="lang == 1" class="search1">جستجو</button>
                <button (click)='open_detaile(0,3,0)' class="search1" *ngIf="lang == 2"
                    [ngClass]="{en_navigation_number:lang==2}" class="search1">Search</button>
                <a id="download" href="{{ site }}/export/{{ export_code }}.xlsx" *ngIf="show_excel == true">
                    <button [ngClass]="{en_navigation_number:lang==2}">
                        <span *ngIf="lang == 2">Excel</span>
                        <span *ngIf="lang == 1">خروجی اکسل</span>
                    </button>
                </a>
                <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-fast-forward"></i></button>
                <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-forward"></i></button>
                <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-backward"></i></button>
                <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-fast-backward"></i></button>
                <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="material-icons pager_icons cursor" (click)="check_access(3,0,selected_record,1,1)">
                delete
            </div>
            <div style="display: inline-block;">
                <mat-checkbox (change)="get_select($event.checked)" [(indeterminate)]="indeterminate"></mat-checkbox>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
    style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
        [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
        [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                <span *ngIf="lang == 1">ردیف</span>
                <span *ngIf="lang == 2">#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + page_number_first }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef style="min-width:200px">
                <span *ngIf="lang == 1">عنوان کالا</span>
                <span *ngIf="lang == 2">Title</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)"
                style="min-width:200px;direction: rtl;" class="right">
                <div class="right">{{x.wharehouse_material_title | substr:0:30 }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="place">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">نام انبار</span>
                <span *ngIf="lang == 2"></span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)">
                <div>{{x.wharehouse_place_title }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="weight">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">واحد</span>
                <span *ngIf="lang == 2"></span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)">
                <div>{{x.wharehouse_weight_title }}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="inventory">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">موجودی</span>
                <span *ngIf="lang == 2">Inventory</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [matMenuTriggerFor]="menu"
                (click)="open_report(x.wharehouse_material_id)">
                {{ x.inventory }}
                <span style="float: left;"><i class="fas fa-info-circle icon"></i></span>
            </mat-cell>
        </ng-container>

        <mat-menu #menu="matMenu" class="material-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td class="right"> + موجودی اول دوره </td>
                    <td> {{ inventory }} </td>
                </tr>
                <tr>
                    <td class="right"> + فاکتور خرید </td>
                    <td> {{ invoice_buy }} </td>
                </tr>
                <tr>
                    <td class="right"> - مصرف شده در سیستم فاکتور </td>
                    <td> {{ consumed_reception}} </td>
                </tr>
                <tr>
                    <td class="right"> - فاکتور فروش </td>
                    <td>{{ invoice_sale }}</td>
                </tr>
                <tr>
                    <td class="right"> - فروش در سایت </td>
                    <td>0</td>
                </tr>
            </table>
        </mat-menu>


        <ng-container matColumnDef="sort">
            <mat-header-cell *matHeaderCellDef [hidden]="true">
                <span *ngIf="lang == 1">ترتیب</span>
                <span *ngIf="lang == 2">Sort</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [hidden]="true"
                (click)="open_detaile(i,2,x.wharehouse_material_id)">{{ x.wharehouse_material_sort }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> وضعیت کالا </span>
                <span *ngIf="lang == 2"> Status</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)">
                <span>{{ x.status_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="service">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> خدمات </span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <span (click)='change_service(i,x.wharehouse_material_service,x.wharehouse_material_id)'>
                    <span *ngIf="x.wharehouse_material_service == 0"><i class="far fa-star icon"></i> </span>
                    <span *ngIf="x.wharehouse_material_service == 1"><i class="fas fa-star icon"
                            style="color: blue;"></i> </span>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ckd">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> عدم ویرایش در ckd </span>
                <span *ngIf="lang == 2">---</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                <span (click)='change_not_update_ckd(i,x.wharehouse_material_not_update_ckd,x.wharehouse_material_id)'>
                    <span *ngIf="x.wharehouse_material_not_update_ckd == 0"><i class="far fa-star icon"></i> </span>
                    <span *ngIf="x.wharehouse_material_not_update_ckd == 1"><i class="fas fa-star icon"
                            style="color: blue;"></i> </span>
                </span>
            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> شناسه </span>
                <span *ngIf="lang == 2">Id</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)">{{
                x.wharehouse_material_id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:100px'>
                <span *ngIf="lang == 1"> عملیات </span>
                <span *ngIf="lang == 2">Operation</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:100px'>
                <mat-checkbox (change)="get_select_records(i)" name="selete_records[]"
                    [value]="x.wharehouse_material_id" [checked]="x.checked" class="hidden-sm hidden-xs"></mat-checkbox>
                <span (click)='open_detaile(i,2,x.wharehouse_material_id)'><i class="fas fa-desktop icon"></i></span>
                <span (click)="check_access(3,0,x.wharehouse_material_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row" [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow
           ,'bg1':row.inventory == 0}" class="cursor"></mat-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview.png">
            </div>
            <div class="preview2" *ngIf="lang == 1">هیچ رکوردی برای نمایش وجود ندارد</div>
            <div class="preview2" *ngIf="lang == 2">There are no records to display</div>
        </div>
    </div>
</div>